module.exports = "/_next/static/images/ico-search-blue-9657def4b3f9adde7742635054e9b703.svg";